(() => {
  class PurchaseAssistant extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.form = document.getElementById(this.dataset.formId);
      this.section = this.closest('[data-product-section]');
      this.primary = this.form?.querySelector('[data-add-to-cart]');
      this.bar = this.querySelector('[data-purchase-bar]');
      this.action = this.querySelector('[data-purchase-action]');
      if (!this.form || !this.section || !this.primary || !this.bar || !this.action) return;
      this.initialized = true;
      this.format = new Intl.NumberFormat(this.dataset.locale || 'de', { style: 'currency', currency: this.dataset.currency || 'EUR' });
      this.update = this.update.bind(this);
      this.frame = null;
      this.schedule = () => {
        if (this.frame !== null) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
      };
      this.go = () => {
        if (this.primary.disabled) return;
        this.primary.scrollIntoView({ block: 'center', behavior: 'auto' });
        this.primary.click();
      };
      this.form.addEventListener('change', this.schedule);
      this.form.addEventListener('input', this.schedule);
      this.action.addEventListener('click', this.go);
      window.addEventListener('scroll', this.schedule, { passive: true });
      window.addEventListener('resize', this.schedule);
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.primary, { attributes: true, childList: true, subtree: true });
      this.update();
    }
    disconnectedCallback() {
      this.form?.removeEventListener('change', this.schedule);
      this.form?.removeEventListener('input', this.schedule);
      this.action?.removeEventListener('click', this.go);
      window.removeEventListener('scroll', this.schedule);
      window.removeEventListener('resize', this.schedule);
      this.observer?.disconnect();
      if (this.frame !== null) cancelAnimationFrame(this.frame);
      this.initialized = false;
    }
    update() {
      const option = this.form.querySelector('[data-variant-select]')?.selectedOptions[0];
      const unit = Number(option?.dataset.priceCents ?? this.dataset.priceCents);
      const quantityInput = this.form.querySelector('[name="quantity"]');
      const quantity = quantityInput?.valueAsNumber ?? 1;
      const valid = Number.isSafeInteger(unit) && unit >= 0 && Number.isSafeInteger(quantity) && quantity > 0;
      if (valid) {
        const subtotal = unit * quantity;
        const threshold = Number(this.dataset.thresholdCents);
        const shipping = threshold > 0 && subtotal >= threshold ? 0 : Number(this.dataset.shippingCents);
        this.section.querySelectorAll('[data-purchase-total]').forEach((output) => {
          output.textContent = this.format.format((subtotal + shipping) / 100);
        });
        this.querySelector('[data-purchase-price]').textContent = this.format.format(subtotal / 100);
      }
      const label = this.primary.querySelector('span')?.textContent.trim() || this.primary.textContent.trim();
      if (this.action.textContent !== label) this.action.textContent = label;
      this.action.disabled = this.primary.disabled || !valid;
      const viewportHeight = window.innerHeight;
      const rect = this.primary.getBoundingClientRect();
      const bounds = this.section.getBoundingClientRect();
      const heading = this.section.querySelector('h1')?.getBoundingClientRect();
      const inDialog = Array.from(document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"], .personalize-pilot-final-review')).some((dialog) => dialog.getClientRects().length > 0);
      const shown = window.innerWidth < 990 && (heading?.top ?? bounds.top) < viewportHeight && bounds.bottom > 100 && bounds.top < viewportHeight;
      const primaryVisible = rect.top < viewportHeight && rect.bottom > 0;
      const visible = shown && !primaryVisible && !inDialog;
      if (this.bar.hidden === visible) this.bar.hidden = !visible;
    }
  }
  if (!customElements.get('purchase-assistant')) customElements.define('purchase-assistant', PurchaseAssistant);
})();
